import CryptoJS from 'crypto-js';

const secretKey = '1234567812345678';

// Function to encrypt the message
export const encryptMessage = (data) => {
    try {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();

        return encrypted;
    } catch (error) {
        console.log('error----', error)
    }

};

// Function to decrypt the message
export const decryptMessage = (data) => {
    try {
        const bytes = CryptoJS.AES.decrypt(data.data, secretKey);
        const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        return decrypted;
    } catch (error) {

    }

};
